export { getCampingQuestion, CampingAnswer } from './CampingFaq';
